
export interface MenuItem {
    text: string;
    icon?: string;
    path?: string;
    subitems?: MenuItem[];
    component?:  () => Promise<() => HTMLElement[]>
}

export interface MenuData {
    title: string;
    items: MenuItem[];
}

export const menuNavigation: MenuData = {
    title: "Menu Principal",
    items: [
        { text: "Painel", icon: '&#127137;', path: "/", component: () => import("@ui/pages").then((module) => module.Painel) },
        { text: "Configuração", icon: '&#127137;', path: "/config", component: () => import("@ui/pages/config").then((module) => module.Config),
            subitems: [
                { text: "Register", icon: '&#127137;', path: "/register", component: () => import("@ui/pages/register").then((module) => module.Register) },
                { text: "Comandos",  icon: '&#127137;',path: "/commands", component: () => import("@ui/pages/commands").then((module) => module.Commands) },
                { text: "About",  icon: '&#127137;', path: "/about", component: () => import("@ui/pages/about").then((module) => module.About) }
            ],
        },
        { text: "Dota 2",  icon: '&#127137;', path: "/dota", component: () => import("@ui/pages/dota").then((module) => module.Dota),
            subitems: [
                { text: "Lista de Heróis",  icon: '&#127137;', path: "/heros", component: () => import("@ui/pages/heros").then((module) => module.Heros) },
            ]
        },
        { text: "Ferramentas",  icon: '&#127137;', path: "/ferramentas", component: () => import("@ui/pages/config").then((module) => module.Ferramentas),
            subitems: [
                { text: "Whatsapp",  icon: '&#127137;', path: "/whatsapp", component: () => import("@ui/pages/whatsapp").then((module) => module.Whatsapp) },
                { text: "Tarot",  icon: '&#127137;', path: "/tarot", component: () => import("@ui/pages/tarot").then((module) => module.Tarot) },

            ]
        },
        {
            text: "Música",
            icon: '&#127137;',
            path: "/musica",
            component: () => import("@ui/pages/musica").then((module) => module.Musica),
            subitems: [
                { text: "Youtube", icon: '&#127137;', path: "/youtube", component: () => import("@ui/pages/youtube").then((module) => module.Youtube) },
                { text: "Spotify", icon: '&#127137;', path: "/spotify", component: () => import("@ui/pages/spotify").then((module) => module.Spotify) },
            ]
        },
    ],
};
